const marchi = {
  "A": [
    {text: "ACQUA BREVETTI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626188590/marchi/AcquaBrevetti_ono4rb.png"},
    {text: "AQUA", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1644937556/marchi/Aqua_q0nsyx.png"},
    {text: "ARISTON", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626188553/marchi/Ariston_arq3ho.png"},
    {text: "AR-THERM", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1706021994/marchi/AR-Therm_hipgjq.png"},
    {text: "ASPEN PUMPS", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1696427968/Pagina_Marche_1_mvwg4s.png"},
    {text: "ASKOLL", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626188623/marchi/Askoll_qhc75h.png"}
  ],
  "B": [
    {text: "BALTUR", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626189387/marchi/Baltur_zyhqps.png"},
    {text: "BANNINGER", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626189299/marchi/Banninger_zt2a7f.png"},
    {text: "BAXI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626189431/marchi/Baxi_egk2oi.png"},
    {text: "BCZ", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1703256509/marchi/BCZ.png"},
    {text: "BELIMO", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1738242638/marchi/BELIMO_enxxbf.png"},
    {text: "BELT", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626189143/marchi/Belt_ui2qtx.png"},
    {text: "BERETTA", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626189341/marchi/Beretta_mhfqjq.png"},
    {text: "BETA", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626189183/marchi/Beta_mi52fb.png"},
    {text: "BIASI | SAVIO", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626189220/marchi/Biasi_b3hplj.png"},
    {text: "BONGIOANNI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1731067810/marchi/BONGIOANNI_1_k3mtpv.png"},
    {text: "BOSCH", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626189262/marchi/Bosch_pujvcb.png"},
    {text: "BRAHMA", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626189104/marchi/Brahama_kiws43.png"}
  ],
  "C": [
    {text: "CADEL", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1696347723/cadel_new_inuj70.png"},
    {text: "CALEFFI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626190016/marchi/Caleffi_gjxrgs.png"},
    {text: "CASTIEL", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1627036114/marchi/Castiel_ohj8em.png"},
    {text: "CASTOLIN", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626189938/marchi/Castolin_1_dnmncn.png"},
    {text: "CIB UNIGAS", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1627036297/marchi/Cib_ln2lxl.png"},
    {text: "CHAFFOTEAUX", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1627036218/marchi/Chaffoteaux_efvv09.png"},
    {text: "CIMM", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626190146/marchi/Cimm_1_tjyjme.png"},
    {text: "COELTE", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626182117/marchi/Coelte_a9eyqs.png"},
    {text: "COES", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626182271/marchi/Coes_j0q6ky.png"},
    {text: "COMPARATO NELLO", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1625999789/marchi/Comparato_Nello_frqvzw.jpg"},
    {text: "CONTI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626182439/marchi/Conti_vvymkz.png"},
    {text: "CORDIVARI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626201081/marchi/Cordivari_sorucg.png"},
    {text: "CORE", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626190112/marchi/Core_1_tovekx.png"},
    {text: "CORH", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626189974/marchi/Corh_s8edff.png"}
  ],
  "D": [
    {text: "DAB", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626183406/marchi/Dab_vbka5u.png"},
    {text: "DANFOSS", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1676901860/marchi/DANFOSS_lgj2dc.png"},
    {text: "DELAVAN", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1741018673/marchi/DELAVAN_1_rz5ypu.png"},
    {text: "DELTA", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626183509/marchi/Delta_ghrn4q.png"},
    {text: "DG FLOW", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626183688/marchi/Dg_fcux7s.png"},
    {text: "DUNGS", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626183799/marchi/Dungs_egb2pw.png"}
  ],
  "E": [
    {text: "EATEC", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626183907/marchi/Eatec_csrqbq.png"},
    {text: "ECOFIT", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1662123647/marchi/Pagina_Marche_mnuskz.png"},
    {text: "ECOFLAM", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626184013/marchi/Ecoflam_tfuehy.png"},
    {text: "ELBI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626184118/marchi/Elbi_qlr3ra.png"},
    {text: "ELEKTROGAS", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626184227/marchi/Elektrogas_jxnqay.png"},
    {text: "ELIWELL", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626184330/marchi/Eliwell_hr4csp.png"},
    {text: "ELLEDI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1644317285/marchi/Elledi_lpevwi.png"},
    {text: "EMMEVI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626184578/marchi/Emmevi_jwktwb.png"},
    {text: "ENOLGAS BONOMI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626184451/marchi/Enolgas_gzuqo6.png"},
    {text: "ESBE", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626184719/marchi/Esbe_oewdsk.png"},
    {text: "ETATRON D.S.", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1676988165/marchi/ETATRON_D.S._rjfihh.png"},
    {text: "EUROACQUE", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626184876/marchi/Euroacque_tungsk.png"},
    {text: "EUROTIS", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626184973/marchi/Eurotis_phbbst.png"},
    {text: "EVCO", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626185117/marchi/Evco_wsbkys.png"}
  ],
  "F": [
    {text: "FANTINI COSMI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626185233/marchi/Fantini_l5qsfw.png"},
    {text: "FBR", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626185455/marchi/Fbr_hytwhj.png"},
    {text: "FERGAS", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1641560523/marchi/Fergas_1_s4s63f.png"},
    {text: "FERRARI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626185582/marchi/Ferrari_a7o0t9.png"},
    {text: "FERROLI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626185688/marchi/Ferroli_tfujek.png"},
    {text: "FIDA", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626185793/marchi/Fida_bjpynu.png"},
    {text: "FIMET", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626185903/marchi/Fimet_bgs25l.png"},
    {text: "FIMI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626000748/marchi/Fimi_vhdsub.jpg"},
    {text: "FISCHER ITALIA", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626186065/marchi/Fischer_1_osfybo.png"},
    {text: "FLEXITALIA", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626186206/marchi/Flexitaly_bydhnx.png"},
    {text: "FORIDRA", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626186339/marchi/Floridra_ffnkqr.png"},
    {text: "FRA.MO.", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626186436/marchi/Framo_dra5u9.png"},
    {text: "FUMASI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626186793/marchi/Fumasi_coexjp.png"}
  ],
  "G": [
    {text: "GALCON", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1714138793/Galcon_yqdt6j.png"},
    {text: "GARNET", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1671713771/marchi/GARNET_cxj3bq.png"},
    {text: "GEBERIT", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626187220/marchi/Geberit_wsvk5i.png"},
    {text: "GEL", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626187365/marchi/Gel_p2ihma.png"},
    {text: "GEORG FISCHER", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626187451/marchi/Georg_rqkrmx.png"},
    {text: "GIORDANO CONTROLS", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626187764/marchi/Giordano_d2vt7i.png"},
    {text: "GIULIANI ANELLO", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626187804/marchi/Giuliani_ljxs54.png"},
    {text: "GRIFFON", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1725376949/marchi/griffon_1_pq4tit.png"},
    {text: "GRUNDFOS", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626187726/marchi/Grundfos_zg4ldx.png"},
    {text: "GS GUARNIGOM", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626187850/marchi/Gs_wqcw47.png"},
    {text: "GT LINE", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1641560231/marchi/Gt_Line_2_meondy.png"},
    {text: "GVR POMPE", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626187407/marchi/Gvr_fcbap1.png"}
  ],
  "H": [
    {text: "HERMANN", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626188250/marchi/Herman_hqxfi1.png"},
    {text: "HERZ", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626188162/marchi/Herz_ka1ifr.png"},
    {text: "HONEYWELL", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626188198/marchi/Honeywell_ncynuo.png"},
    {text: "HUNTER", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626188123/marchi/Hunter_ldiagl.png"}
  ],
  "I": [
    {text: "IMIT", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626190749/marchi/Imit_pfb1p0.png"},
    {text: "IMMERGAS", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626190826/marchi/Immergas_iao0n1.png"},
    {text: "IMP PUMPS", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1672763181/marchi/IMP_PUMPS_ajcleb.png"},
    {text: "INDUSTRIE TECHNIK", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626190790/marchi/Industrie_wt6rs5.png"},
    {text: "IONICORE", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1644852644/marchi/Ionicore_qv72qv.png"},
    {text: "IRRITEC", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626190897/marchi/Irritec_xpthu7.png"},
    {text: "ITALTECNICA", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626191074/marchi/Italtecnica_tpvps6.png"},
    {text: "IVAR", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626190863/marchi/Ivar_byrowy.png"}
  ],
  "J": [
    {text: "JOHNSON CONTROLS", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626190967/marchi/Johnson_xcnmq5.png"},
    {text: "JUNKERS – (BOSCH)", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626191005/marchi/junkers_w5ap6r.png"}
  ],
  "K": [
    {text: "K-RAIN", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1715011002/marchi/KRAIN_pcmpv7.png"},
    {text: "KELVION", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626191040/marchi/kelvion_wf0ils.png"},
    {text: "KLOBEN", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626191111/marchi/kloben_mvteec.png"}
  ],
  "L": [
    {text: "LAMBORGHINI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626191723/marchi/Lamborghini_eu6f5j.png"},
    {text: "LAMINOX", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1737460408/marchi/Laminox_1_oxcet4.png"},
    {text: "LAZZARI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626191583/marchi/Lazzari_pc8p4n.png"},
    {text: "LINEA VZ", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626191548/marchi/Linea_azp29z.png"},
    {text: "LIRA", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626191650/marchi/Lira_ng3ton.png"},
    {text: "LK", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1646315742/marchi/LK_axazla.png"},
    {text: "LOWARA", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626191617/marchi/Lowara_eprloi.png"}
  ],
  "M": [
    {text: "MADDALENA", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626192507/marchi/Maddalena_macx2z.png"},
    {text: "MAXIFLAME", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626192462/marchi/Maxiflame_xrf0wz.png"},
    {text: "MCZ", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626192270/marchi/Mcz_nolkyn.png"},
    {text: "MGF", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626192305/marchi/Mgf_wlilxx.png"},
    {text: "MONARCH", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626192419/marchi/Monarch_d9afdl.png"},
    {text: "MONDEO", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626192386/marchi/Mondeo_hotgrh.png"},
    {text: "MUT MECCANICA TOVO", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626192338/marchi/Mut_mpwdsj.png"}
  ],
  "N": [
    {text: "NETSOFTWARE", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626192991/marchi/Net_jnpdvg.png"},
    {text: "NOVA COMET", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626192959/marchi/Novacomet_ugzcky.png"},
    {text: "NUOVE ENERGIE - (VIESSMANN GROUP)", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626192921/marchi/NuoveEnergie_xjbatw.png"}
  ],
  "O": [
    {text: "OCEAN – (BAXI)", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626193145/marchi/Ocean_nzvk0d.png"},
    {text: "O.ERRE", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626193069/marchi/Oerre_ld37zy.png"},
    {text: "ORBIS", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626193100/marchi/Orbis_uz6iu1.png"},
    {text: "ORBIT", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626193035/marchi/Orbit_xe9elx.png"},
    {text: "OVENTROP", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626193179/marchi/Oventrop_ao59am.png"}
  ],
  "P": [
    {text: "PARIGI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626193539/marchi/Parigi_u38gjk.png"},
    {text: "PEDROLLO", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626193574/marchi/Pedrollo_c7jqqz.png"},
    {text: "PEL PINTOSSI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626193639/marchi/Pel_d3oncf.png"},
    {text: "PERLA - (ARISTON)", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626193713/marchi/Perla_fvag26.png"},
    {text: "PIUSI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626193605/marchi/Piusi_jftbkv.png"},
    {text: "POMPE VERGANI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626193676/marchi/Pompe_sjtygu.png"},
    {text: "PROFINE", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1644832705/marchi/Profine_gqvsgl.png"}
  ],
  "R": [
    {text: "R.B.M.", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626194613/marchi/Rbm_avhx2c.png"},
    {text: "RADI - (ARISTON)", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626193835/marchi/Radi_cx7p9v.png"},
    {text: "RAIN", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626193909/marchi/Rain_soctxa.png"},
    {text: "RAIN BIRD", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1667830488/marchi/RAIN_BIRD_zuzhzl.png"},
    {text: "RAVELLI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626194543/marchi/Ravelli_s1kp7i.png"},
    {text: "RESIDEO – (HONEYWELL)", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626194444/marchi/Resideo_kouxlq.png"},
    {text: "RIELLO", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626194476/marchi/Riello_rb4sp9.png"},
    {text: "RIZZO", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626194580/marchi/Rizzo_vfgvmm.png"},
    {text: "ROTFIL", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626194413/marchi/Rotfil_rxy36a.png"},
    {text: "ROTHENBERGER", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626194510/marchi/Rothenberger_tb959z.png"}
  ],
  "S": [
    {text: "SALMSON", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626195877/marchi/Salmson_rlbavo.png"},
    {text: "SAUERMANN", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626195909/marchi/Sauermann_mxfb02.png"},
    {text: "SAUNIER DUVAL", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626194956/marchi/Saunier_thckjn.png"},
    {text: "BIASI | SAVIO", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626195945/marchi/Savio_me9fdc.png"},
    {text: "SEITRON", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626195983/marchi/Seitron_lpahjb.png"},
    {text: "SESTA", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626196022/marchi/Sesta_jyrghy.png"},
    {text: "SIEMENS", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626196066/marchi/Siemens_iv83mt.png"},
    {text: "SIGGI", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626195167/marchi/Siggi_nxbyih.png"},
    {text: "SIMAT - (ARISTON)", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626196101/marchi/Simat_vac0uv.png"},
    {text: "SIME", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626196932/marchi/Sime_i1bk93.png"},
    {text: "SIMEL", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626196201/marchi/Simel_a5cgly.png"},
    {text: "SIT", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626196158/marchi/Sit_tooiml.png"},
    {text: "SITAM - (ARISTON)", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626195838/marchi/Sitam_zuj6wa.png"},
    {text: "SNICKERS", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626195789/marchi/Snickers_rv7wbt.png"},
    {text: "SOLAHART", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626196312/marchi/Solahart_xiwcqi.png"},
    {text: "SPG", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1674823390/marchi/Pagina_Marche_1_pvcug4.png"},
    {text: "STEINEN", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1741262632/marchi/STEINEN_khbajp.png"},
    {text: "SUNTEC", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626196864/marchi/Suntec_rdnazp.png"},
    {text: "SYLBER", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626196260/marchi/Sylber_flg70a.png"}
  ],
  "T": [
    {text: "TACO - (ASKOLL)", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626197539/marchi/Taco_jl1dqi.png"},
    {text: "TECNOCONTROL", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626197570/marchi/TecnoControl_q4ptcj.png"},
    {text: "TECNOGAS", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1744729321/marchi/TECNOGAS_wnrpsv.png"},
    {text: "TESTO", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626197502/marchi/Testo_owjzs8.png"},
    {text: "THEBEN", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626197667/marchi/Theben_obg5nv.png"},
    {text: "THERMEX", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626197632/marchi/Thermex_rbj46k.png"},
    {text: "T.M.T.", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626197600/marchi/TMT_tajs8h.png"}
  ],
  "U": [
    {text: "UNGARO", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626197997/marchi/Ungaro_bps2oj.png"},
    {text: "UNIDELTA", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626197958/marchi/Unidelta_ztz1ml.png"},
    {text: "UNIFIX", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626198030/marchi/Unifix_laebsr.png"},
    {text: "U-POWER", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626198060/marchi/U-power_owa5l9.png"}
  ],
  "V": [
    {text: "VAILLANT", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626200324/marchi/Vaillant_utcshl.png"},
    {text: "VALCO", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626200287/marchi/Valco_n7cb2g.png"},
    {text: "VIESSMANN GROUP", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626200360/marchi/Viessmann_sm2xjp.png"}
  ],
  "W": [
    {text: "WATTS", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626200686/marchi/Watts_z80zfe.png"},
    {text: "WIGAM", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626200759/marchi/Wigam_trpvi1.png"},
    {text: "WILO", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626200727/marchi/Wilo_uohcy5.png"}
  ],
  "X": [
    {text: "XYLEM – (LOWARA)", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626200792/marchi/Xylem_h4zcsg.png"}
  ],
  "Z": [
    {text: "ZEP", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626200826/marchi/Zep_ceczg8.png"},
    {text: "ZILMET", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1626200876/marchi/Zilmet_gcz9uf.png"}
  ],
  "*": [
    {text: "***", href: "https://res.cloudinary.com/arc-verrino-srl/image/upload/v1663961610/marchi/No-brand_g8zej0.png"}
  ]
}


function setCategoryProduct(collections, tags) {

  var initialElements = []
  var collectionsHttpLinks = []

  for (let index in collections) {
    if (collections[index]) {
      collections[index].rules.every(element => {
        if(tags.includes(element.condition.toLowerCase())) {
          if(!element.condition.match(/^\d/)) {
            // collectionsHttpLinks.push(createLinkCategory(collections[index].handle))
            initialElements.push({...element, 'handle': collections[index].handle, 'title': collections[index].title})
          }
        }
      })
    }
  }
  let sorted = sortCollections(initialElements)
  collectionsHttpLinks = sorted.length < 3 ? sorted : sorted.splice(0, 3) 
  document.addEventListener('DOMContentLoaded', function(event) {
    var td = document.getElementById('collection-links')
    collectionsHttpLinks.forEach((element, key) => {
      if(collectionsHttpLinks.length - 1 === 0) {
        td.innerHTML = `<a target="_blank" href="${element.link}">${element.title}</a>, `
      } else if(collectionsHttpLinks.length - 1 === key) {
        td.innerHTML += `<a target="_blank" href="${element.link}">${element.title}</a>`
      } else {
        td.innerHTML += `<a target="_blank" href="${element.link}">${element.title}</a>, `
      }
    })
    if (sorted.length > 0) {
      td.innerHTML += `<br>`
      sorted.forEach((element, key) => {
      if(sorted.length - 1 === 0) {
        td.innerHTML += `<a target="_blank" href="${element.link}">${element.title}</a>, `
      } else if(sorted.length - 1 === key) {
        td.innerHTML += `<a target="_blank" href="${element.link}">${element.title}</a>`
      } else {
        td.innerHTML += `<a target="_blank" href="${element.link}">${element.title}</a>, `
      }
    })
    }
  })
}

function createLinkCategory(handle) {
  var getUrl = window.location
  return getUrl.protocol + "//" + getUrl.host + "/collections/" + handle
}

function sortCollections(elements) {
  var ordersCollections = {
    'acqua': ['prodotti', 'trattamento-acque-potabili', 'irrigazione', 'idraulica-casa'],
    'aria': ['condizionamento'],
    'gas': ['bruciatori', 'caldaie-murali', 'grandi-cucine', 'scaldacqua'],
    'gasolio': ['prodotti-gasolio'],
    'pellet': ['ricambi'],
    'solare-termico': ['circolazione-forzata', 'circolazione-naturale'],
    'prodotti-chimici': ['articoli', 'prodotti-di-consumo'],
    'strumenti': ['prodotti-strumenti'],
    'termoregolazione': ['prodotti-termoregolazione'],
    'abbigliamento-da-lavoro': ['primo-strato', 'secondo-strato', 'parti-inferiori', 'capispalla', 'accessori-calzature'],
    'attrezzature': ['utensili', 'porta-utensili']
  }
  var orderedCollectionsLinks = []
  var foundElement = [];

  // controlliamo i motori
  let gasIndex = elements.findIndex(ele => ele.condition.toLowerCase() === 'gas')
  let gasolioIndex = elements.findIndex(ele => ele.condition.toLowerCase() === 'gasolio')
  if (gasIndex !== -1 && gasolioIndex !== -1) {
    orderedCollectionsLinks.push({title: elements[gasIndex].title, link: createLinkCategory(elements[gasIndex].handle)})
    let secondI = elements.findIndex(ele => ele.condition.toLowerCase() === 'bruciatori')
    let thirdI = elements.findIndex(ele => ele.condition.toLowerCase() === 'motori-gas')
    let fifthI = elements.findIndex(ele => ele.condition.toLowerCase() === 'prodotti-gasolio')
    let sixthI = elements.findIndex(ele => ele.condition.toLowerCase() === 'motori-gasolio')
    orderedCollectionsLinks.push({title: elements[secondI].title, link: createLinkCategory(elements[secondI].handle)})
    orderedCollectionsLinks.push({title: elements[thirdI].title, link: createLinkCategory(elements[thirdI].handle)})
    orderedCollectionsLinks.push({title: elements[gasolioIndex].title, link: createLinkCategory(elements[gasolioIndex].handle)})
    orderedCollectionsLinks.push({title: elements[fifthI].title, link: createLinkCategory(elements[fifthI].handle)})
    orderedCollectionsLinks.push({title: elements[sixthI].title, link: createLinkCategory(elements[sixthI].handle)})
    return orderedCollectionsLinks
  }
  // fine controllo motori

  for ([key, value] of Object.entries(ordersCollections)) {
    var i = elements.findIndex(ele => ele.condition.toLowerCase() === key)
    if (i === -1) {
      continue
    } else {
      foundElement = value
      orderedCollectionsLinks.push({title: elements[i].title, link: createLinkCategory(elements[i].handle)})
      elements.splice(i, 1)
      break
    }
  }
  elements.forEach((el, index) => {
    if(foundElement.length && foundElement.includes(el.condition.toLowerCase())) {
      orderedCollectionsLinks.push({title: el.title, link: createLinkCategory(el.handle)})
      elements.splice(index, 1)
    }
  })
  // the last link
  orderedCollectionsLinks.push({title: elements[0].title, link: createLinkCategory(elements[0].handle)})

  return orderedCollectionsLinks
}

// Funzione per ottimizzare la Login di WAIO
function displayOrNotBasedOnUserTipology() {
  window.addEventListener('wsaio-customer-form-embed', ()  => {
    console.log('eccome')
  })
}